import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { Form } from 'semantic-ui-react';
import { fetchRequirements } from '../actions/requirements';
import General from './General';
import Invoicing from './Invoicing';

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchRequirements: () => dispatch(fetchRequirements(ownProps.id)),
});

export class Page extends React.Component {
  componentWillMount() {
    this.props.fetchRequirements();
  }

  render() {
    return (
      <Form>
        <General
          id={this.props.id}
          isExisting={this.props.isExisting}
          contractId={this.props.contractId}
          customerId={this.props.customerId}
          startContractDate={this.props.startContractDate}
        />
        <Invoicing
          id={this.props.id}
          contractId={this.props.contractId}
          isExisting={this.props.isExisting}
        />
      </Form>
    );
  }
}

Page.propTypes = {
  id: PropTypes.number.isRequired,
  customerId: PropTypes.number.isRequired,
  fetchRequirements: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/renew/components/Page.js